import React, { Fragment, useEffect, useState } from 'react';
import { LockOpen, ArrowForward, } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { Box, Card, Button, CardContent, Divider, Grid, Typography, Container, Tabs, Tab } from '@mui/material';
import clsx from 'clsx';
//* Import Component
import colors from 'app/style/colors';
import Images, { Loader } from 'assets/Images';
import Register from '../Session/Register/Register';
import Layout from 'app/layout/Layout';
import { Service } from 'app/config/service';

const useStyle = makeStyles({
  tabButton: {
    fontSize: '18px !important',
    cursor: 'pointer',
    color: colors.black,
    '&:hover': {
      color: colors.primary,
      borderBottom: `2px solid ${colors.primary}`
    }
  },
  active: {
    color: colors.primary,
    borderBottom: `2px solid ${colors.primary}`
  },

})


function Learning() {

  const classes = useStyle();

  const [openRegister, setOpenRegister] = useState(false);

  const [isActive, setIsActive] = useState(null);

  // *For Set Course Id
  const [courseId, setCourseId] = useState(null);

  // *For Trainings
  const [trainings, setTrainings] = useState([]);
  const [category, setCategory] = useState([]);

  const [loader, setLoader] = useState(true);

  const getTrainings = async () => {
    try {
      const limit = 10
      const page = 1
      const { Data } = await Service.getTraining(limit, page)
      setTrainings(Data)
      setIsActive(null)
    } catch (error) {
      console.log('file: Learning.js => line 30 => getTrainings => error', error)
    }
  }

  const getCategory = async () => {
    try {
      const { Data } = await Service.getCategory()
      setCategory(Data)
      setLoader(false)
    } catch (error) {
      console.log('file: Learning.js => line 42 => getCategory => error', error)
    }
  }

  const getTrainingsById = async (id) => {
    try {
      const limit = 10
      const page = 1
      const { Data } = await Service.getTrainingsById(limit, page, id)
      setTrainings(Data)
    } catch (error) {
      console.log('file: Learning.js => line 42 => getCategory => error', error)
    }
  }

  useEffect(() => {
    getTrainings()
    getCategory()
  }, []);

  //* Scroll Tab
  const [scrollValue, setScrollValue] = useState(0);

  const handleScroll = (event, newValue) => {
    setScrollValue(newValue);
  };

  return (
    <Layout>

      {/* Register Section  */}
      <Register openRegister={openRegister} handleRegisterDialog={() => setOpenRegister(!openRegister)} courseId={courseId} />
      {/*End Register Section */}
      {/* ========== Service Banner ========== */}
      <Container>

        <Box sx={{
          marginTop: 1.2, borderRadius: '14px',
          background: `linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(${Images.learningSectionBanner})`,
          height: 300, position: 'sticky', p: 4, opacity: 1, backgroundRepeat: 'no-repeat', backgroundSize: 'cover'
        }
        }>


          <Typography variant="h2" sx={{
            color: colors.white, textAlign: 'center', marginTop: '100px', fontWeight: 'bold'
          }}>
            Learning
          </Typography>
          <Divider
            sx={{
              bgcolor: colors.primary,
              width: '140px',
              padding: '1px',
              margin: 'auto',
              fontSize: '28px',
              mb: 1
            }}
          />

          <Divider
            sx={{
              bgcolor: colors.primary,
              width: '100px',
              padding: '1px',
              margin: 'auto',
              fontSize: '28px'
            }}
          />
        </Box>

        <Grid container sx={{
          display: 'flex', justifyContent: 'center', mt: 10,
          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1268%26quot%3b)' fill='none'%3e%3cpath d='M74.87 492.46 a38.49 38.49 0 1 0 76.98 0 a38.49 38.49 0 1 0 -76.98 0z' fill='rgba(255%2c 232%2c 225%2c 1)'%3e%3c/path%3e%3cpath d='M801.85 153.04L839.84 153.04L839.84 191.03L801.85 191.03z' stroke='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M200.23 20.89L209.8 20.89L209.8 66.79L200.23 66.79z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M317.14 394.65L363.03 394.65L363.03 440.54L317.14 440.54z' stroke='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M245.02 322.08L283.28 322.08L283.28 360.34L245.02 360.34z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M487.5 518.99a42.13 42.13 0 1 0-23.05 81.04z' stroke='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M831.12 511.67L881.57 511.67L881.57 562.12L831.12 562.12z' fill='rgba(255%2c 232%2c 225%2c 1)'%3e%3c/path%3e%3cpath d='M342.96 232.8 a52.38 52.38 0 1 0 104.76 0 a52.38 52.38 0 1 0 -104.76 0z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M-37 89.59 a50.11 50.11 0 1 0 100.22 0 a50.11 50.11 0 1 0 -100.22 0z' fill='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M1325.93 276.62L1354.72 276.62L1354.72 298.7L1325.93 298.7z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M350.22 111.99a35.59 35.59 0 1 0-64.17-30.8z' stroke='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M1429.36 290.03L1442.59 290.03L1442.59 305.39L1429.36 305.39z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M1305.65 280.72 a36.99 36.99 0 1 0 73.98 0 a36.99 36.99 0 1 0 -73.98 0z' stroke='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M1329.83 236.02L1337.62 236.02L1337.62 243.81L1329.83 243.81z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M829.89 476.16L840.97 476.16L840.97 487.24L829.89 487.24z' fill='rgba(255%2c 232%2c 225%2c 1)'%3e%3c/path%3e%3cpath d='M245.79 485.2L291.6 485.2L291.6 531.01L245.79 531.01z' fill='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M670.21 277.17L720.68 277.17L720.68 327.64L670.21 327.64z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M1285.95 400.18a29.54 29.54 0 1 0-46.82-36.03z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M1218.35 354.45 a10.72 10.72 0 1 0 21.44 0 a10.72 10.72 0 1 0 -21.44 0z' fill='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M588.77 331.99a11.21 11.21 0 1 0 4.34 21.99z' fill='rgba(255%2c 232%2c 225%2c 1)'%3e%3c/path%3e%3cpath d='M880.64 363.04L906.15 363.04L906.15 388.55L880.64 388.55z' stroke='rgba(255%2c 232%2c 225%2c 1)'%3e%3c/path%3e%3cpath d='M1229.89 480.78L1254.95 480.78L1254.95 505.84L1229.89 505.84z' fill='rgba(255%2c 232%2c 225%2c 1)'%3e%3c/path%3e%3cpath d='M1063.99 163.55a13.09 13.09 0 1 0-24.42-9.42z' fill='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M350.14 388.63L394.98 388.63L394.98 434.84L350.14 434.84z' stroke='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M1097.88 66.37L1124.01 66.37L1124.01 88.36L1097.88 88.36z' stroke='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M953.92 168.08L995.52 168.08L995.52 209.68L953.92 209.68z' stroke='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M329.57 242.24L379.01 242.24L379.01 291.68L329.57 291.68z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M1224.99 229.65L1274.28 229.65L1274.28 278.94L1224.99 278.94z' fill='rgba(255%2c 232%2c 225%2c 1)'%3e%3c/path%3e%3cpath d='M1290.75 30.15L1299.26 30.15L1299.26 38.66L1290.75 38.66z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M879.67 95.73L902.47 95.73L902.47 118.79L879.67 118.79z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M679.8 441.15 a30.87 30.87 0 1 0 61.74 0 a30.87 30.87 0 1 0 -61.74 0z' stroke='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M1328.84 231.78a2.83 2.83 0 1 0-0.27-5.65z' fill='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M972.1 417.24 a2.03 2.03 0 1 0 4.06 0 a2.03 2.03 0 1 0 -4.06 0z' stroke='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1268'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e");`,
        }}>
          <Grid item xs={12} md={5} sx={{ textAlign: "center", my: -2 }}>
            <img src={Images.learningSectionDetail} width="100%" alt="" />
          </Grid>
          <Grid item xs={12} md={5}>
            <Typography variant='h4' sx={{ mb: 2, fontWeight: 'bold', color: colors.black }}>Great Entrepreneurs are Built Here
              <span style={{ color: colors.primary }}>?</span>
            </Typography>
            <Typography
              gutterbottom
              sx={{ color: colors.textPrimary, bgcolor: colors.white, fontSize: '18px' }}
            >
              The ecommerce industry is growing at an impressive rate, with opportunities for entrepreneurs who can take advantage of this trend. These Training Programs offer passionate trainers that will guarantee success from their top-notch expertise in 6 different verticals.
            </Typography>
            <Typography
              sx={{ color: colors.textPrimary, bgcolor: colors.white, fontSize: '18px' }}
            >
              The Mashr is committed to giving everyone the chance and opportunity for success. We understand how challenging it might seem when you have limited funds, so apply now to our upcoming training sessions where training is tailored specifically towards those with smaller budgets who wish to start earning money from home as freelancers or virtual assistants through skill development.
            </Typography>
          </Grid>
        </Grid>

      </Container>

      {/* Training Courses */}
      <Box sx={{
        my: 2, mt: 8, mx: 'auto', width: '70%', display: 'flex',
        justifyContent: 'center', bgcolor: 'background.paper'
      }}>
        <Tabs
          value={scrollValue}
          onChange={handleScroll}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example">
          <Tab
            label="All"
            className={clsx(classes.tabButton, { [classes.active]: isActive === null, })} onClick={() => { getTrainings(); setIsActive(null) }}
          />
          {category.map((item, index) => (
            <Tab
              label={item.Category}
              key={index} className={clsx(classes.tabButton, { [classes.active]: isActive === item.Id, })} onClick={() => { getTrainingsById(item.Id); setIsActive(item.Id) }}
              sx={{ mx: 1 }}
            />
          ))}
        </Tabs>
      </Box>
      <Container>
        <Grid container spacing={3}
          sx={{ mt: '50px', mb: '40px' }}
        >
          {trainings.length > 0 ? (
            <Fragment>
              {trainings.map((item, index) => (
                <Grid key={index} item xs={12} md={4} >
                  <Card
                    sx={{
                      borderRadius: '14px', boxShadow: 3,
                      color: colors.white,
                      transition: "all 0.3s ease-in",
                      '&:hover': {
                        cursor: 'pointer',
                        boxShadow: 5,
                        transform: 'scale(1.05)'
                      }

                    }}>
                    <CardContent
                      sx={{ textDecoration: 'none', p: 0 }}
                    >
                      <Box
                        component={Link} to={`/training/${item.Id}`}>
                        <img
                          src={item.BannerImage} width='100%' height='230px' alt=""
                          style={{ borderRadius: '14px', backgroundPosition: 'center', margin: "auto" }} />
                      </Box>
                      <Typography variant='h5'
                        sx={{
                          textAlign: 'center', mb: 1, color: colors.black
                        }}>{item.CourseName}</Typography>
                      <Typography variant='body2'
                        sx={{
                          textAlign: 'center',
                          color: colors.textPrimary,
                          px: 2,
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                          display: '-webkit-box',
                          '-webkit-line-clamp': '3',
                          '-webkit-box-orient': 'vertical'
                        }}
                      >
                        {item.BriefOverview}
                      </Typography>
                      {/* <Typography variant="body2" sx={{ my: 1, fontWeight: 'bold', color: colors.primary }}>Created by Mashr</Typography> */}

                      <Box sx={{ textAlign: 'center', mt: 2.5 }}>
                        <Button variant="contained"
                          endIcon={<LockOpen />}
                          onClick={() => { setOpenRegister(!openRegister); setCourseId(item.Id) }}
                          sx={{ color: colors.white, mr: 2, textDecoration: 'none', mb: 1.5 }}>Register</Button>
                        <Button variant="outlined"
                          component={Link} to={`/training/${item.Id}`}
                          endIcon={<ArrowForward />}
                          sx={{ color: colors.primary, textDecoration: 'none', mb: 1.5 }}>Know More</Button>
                      </Box>
                    </CardContent>

                  </Card>
                </Grid>
              ))}
            </Fragment>
          ) : (
            <Box sx={{ my: 2, width: 1, textAlign: "center" }}>
              {loader && <Loader />}
              {category.length === 0 && loader === false && <Typography variant="h6" >No Course Found</Typography>}
            </Box>
          )}


        </Grid>
      </Container>
    </Layout>
  )
}

export default Learning